import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { AudienceService } from 'app/library/audience/services/audience.service';

@Component({
    selector: 'app-grow-new-sub-audience-dialog',
    templateUrl: './grow-new-sub-audience-dialog.component.html',
    styleUrls: ['./grow-new-sub-audience-dialog.component.scss'],
})
export class GrowNewSubAudienceDialogComponent implements OnInit {
    @Input()
    audienceId: string;

    @Input()
    audienceName: string;

    @ViewChild('btnRef') buttonRef: MatButton;

    get name() {
        return this.formGroup.get('name');
    }

    private _formGroup: FormGroup;

    get formGroup(): FormGroup {
        return this._formGroup;
    }

    constructor(private _formBuilder: FormBuilder, public dialogRef: MatDialogRef<GrowNewSubAudienceDialogComponent>, public audienceService: AudienceService) {}

    ngOnInit() {
        this._formGroup = this._formBuilder.group({
            name: ['', Validators.required],
        });
    }

    handleKeyUp(e) {
        // KEYCODE 13 (ENTER), input is in focus while typing
        if (e.keyCode === 13) {
            this.onAddNewSubAudience();
        }
    }

    async onAddNewSubAudience() {
        const audience = this.formGroup.value;
        audience.parent = { id: this.audienceId };
        this.dialogRef.close(await this.audienceService.createAudience(audience));
    }
}
